import { defineComponent as o, openBlock as r, createBlock as l, unref as p, mergeProps as i, withCtx as m, createElementVNode as t } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const v = /* @__PURE__ */ o({
  name: "IconExternalLink",
  __name: "IconExternalLink",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const a = n;
    return (s, e) => (r(), l(p(c), i(a, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        t("path", { d: "M14.25 3.5A.75.75 0 0 1 15 2.75h5A1.25 1.25 0 0 1 21.25 4v5a.75.75 0 0 1-1.5 0V5.31l-6.22 6.22a.75.75 0 1 1-1.06-1.06l6.22-6.22H15a.75.75 0 0 1-.75-.75" }, null, -1),
        t("path", { d: "M5.75 6.5A.75.75 0 0 1 6.5 5.75H12a.75.75 0 0 0 0-1.5H6.5A2.25 2.25 0 0 0 4.25 6.5v11a2.25 2.25 0 0 0 2.25 2.25h11a2.25 2.25 0 0 0 2.25-2.25V12a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 1-.75.75h-11a.75.75 0 0 1-.75-.75v-11" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
